import { Action } from "@reduxjs/toolkit"
import { ContactState } from "./types"
import { isType } from "typescript-fsa"
import { contactActions } from "./actions"

const initialState: ContactState = {
    contact: null,
}

export function ContactReducer(state = initialState, action: Action): ContactState {
    if (isType(action, contactActions.contactForm.done)) {
        const data = action.payload.params
        return {
            ...state,
            contact: {
                first_name: data.first_name,
                last_name: data.last_name,
                email: data.email,
                phone_number: data.phone_number,
                message: data.message,
            }
        }
    }

    if (isType(action, contactActions.resetToInitialState)) {
        return initialState;
      }
      return state;
}